import { Box } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckMarkCircleIcon } from '~/assets/icons';
import classNames from 'classnames/bind';
import styles from './Completed.module.scss';
const cx = classNames.bind(styles);

const Completed = () => {
  const { t } = useTranslation('admin/esign');

  return (
    <Box className='flex w-full h-full'>
      <Box className='flex-1 flex-col flex justify-center items-center'>
        <Box className='w-[200px] h-[150px] flex items-center justify-center'>
          <CheckMarkCircleIcon className={cx('success-icon')} />
        </Box>
        <Box className='text-center font-bold'>{t('completed.title')}</Box>
        <Box className='text-center'>{t('completed.description')}</Box>
      </Box>
    </Box>
  );
};

export default memo(Completed);
